package com.anjuros.website.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.TemplatesHeader
import com.anjuros.website.components.changeMode
import com.anjuros.website.components.detectLanguage
import com.anjuros.website.components.detectMode
import com.anjuros.website.components.language.Language
import com.anjuros.website.components.language.LanguageContext
import com.anjuros.website.components.language.LocalLanguage
import com.anjuros.website.components.language.LocalUiMode
import com.anjuros.website.components.language.ResKey
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.components.language.isContentSelected
import com.anjuros.website.components.shared.TemplatePromoFab
import com.anjuros.website.templates.mix.modules.HintBoxDisplay
import com.anjuros.website.templates.selection.styles.HeaderHeight
import com.anjuros.website.templates.template8.components.Template8OverflowMenu
import com.anjuros.website.templates.template8.sections.GoldLine
import com.anjuros.website.templates.template8.sections.Template8FooterSection
import com.anjuros.website.templates.template8.sections.Template8MenuSection
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.localStorage
import org.jetbrains.compose.web.css.Position

@Page
@Composable
fun PubLearnMenuWebsiteDesignUk() {
    var lang by remember { mutableStateOf(Language.EN) }
    val uiMode = remember { mutableStateOf<UiMode?>(null) }
    var showModeToggleSpotlight by remember { mutableStateOf(false) }

    androidx.compose.runtime.LaunchedEffect(Unit) {
        lang = detectLanguage()
        uiMode.value = detectMode()
        showModeToggleSpotlight =
            uiMode.value != null && localStorage.getItem(HintBoxDisplay).isNullOrEmpty()
    }
    val languageContext = remember(lang) {
        LanguageContext(
            lang = lang,
            setLang = { lang = it }
        )
    }
    var menuOpened by remember { mutableStateOf(false) }
    val contentMode = uiMode.value ?: UiMode.NORMAL
    CompositionLocalProvider(
        LocalLanguage provides languageContext,
        LocalUiMode provides contentMode
    ) {
        Box(modifier = Modifier.fillMaxSize()) {

            Column(
                modifier = Modifier.fillMaxSize().zIndex(2.0),
                verticalArrangement = Arrangement.Top,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {


                Template8MenuSection(
                    modifier = HeaderHeight.toModifier()
                ) {
                    menuOpened = true
                }
                GoldLine()
                Template8FooterSection()
            }

            TemplatesHeader(
                modifier = Modifier.align(Alignment.TopCenter)
                    .position(Position.Fixed)
                    .zIndex(3),
                header = ResKey.TEMPLATE8_HEADER_SUBPAGE1,
                subHeader = ResKey.TEMPLATE8_SUBHEADER_SUBPAGE1,
                showModeToggleSpotlight = showModeToggleSpotlight,
                contentModeSelected = uiMode.value.isContentSelected(),
                onChangeMode = { newMode ->
                    uiMode.value = newMode
                    changeMode(newMode)
                }
            )
            if (menuOpened) {
                Template8OverflowMenu { menuOpened = false }
            }
            TemplatePromoFab()
        }
    }
}